const buttonCls = "_086b1ajgvkk";

export { buttonCls };
import "./atom.button.style.linaria.module.css";
//# sourceMappingURL=atom.button.style.js.map
